<div class="fd m_t_10" *ngIf="ProviderImages?.length  ">
    <div class="flex_side">
        <span routerLink="/providers" class="hover_ef">
            <img src="../../../assets/siteImg/IconsC/Providers.svg" alt="Slot Games" width="30" height="30">{{'PROVIDERS' | translate}}
        </span>
         <div class="Arrows ">
            <button class="left_Arrow"  aria-label="Previous slide"  (click)="providerscrollLeft()"
                [disabled]="providerLeftArrowDisabledVal"  [attr.aria-disabled]="providerLeftArrowDisabledVal">
                <i class='fas fa-angle-left' style='font-size:18px'></i>
            </button>

            <button class="right_Arrow"  aria-label="Next slide"  (click)="providerscrollRight()"
                [disabled]="providerRightArrowDisabledVal">
                <i class='fas fa-angle-right' style='font-size:18px;'></i>
            </button>
        </div>
    </div>
    <div class="providerImg " #widgetsprovider (scroll)="ProviderScrollButtons()">
        <ng-container *ngFor="let tom of providerJSON; let i = index">
        <div class="imageWidth scalImg " (click)="routerLinksprovider(tom)" *ngIf="tom !== 'powerplay' && tom !== 'wearelotto'">
            <img   src="../../../assets/siteImg/Providers/{{tom}}.svg" alt="{{tom}}" class="providerImage">
        </div>
    </ng-container>

    </div> 
</div>